import {
    createPageMetricsForResponse,
    PageType,
} from '@jet-app/music-classical/metrics/page';
import { ObjectGraph } from '@jet/environment/dependencies';

import type { HomePage, PageHeaderType } from '@jet-app/music-classical/models';
import type {
    ClassicalAPIResponse,
    ClassicalAPIResponseHeader,
} from '@jet-app/music-classical/api/types';
import { getBaseSeoData } from '@jet-app/music-classical/utilities/seo/BaseSeoData';
import { type HomePageIntent } from '../HomeIntent';
import { pageSubscriptionStatusChangeEventTrigger } from '../common/page-invalidation-rules';
import type { Opt } from '@jet/environment';
import type { SectionInvalidationRules } from '../../models/invalidation/InvalidationRules';
import { buildHomePageSections } from './utils';

export function renderHomePage(
    pageIntent: HomePageIntent,
    canonicalURL: string,
    apiResponse: ClassicalAPIResponse,
    objectGraph: ObjectGraph,
    sectionInvalidationRules?: Opt<SectionInvalidationRules>,
): HomePage {
    const responseHeader = apiResponse?.body
        ?.header as unknown as ClassicalAPIResponseHeader;

    return {
        kind: 'homePage',
        pageKind: 'browsePage',
        header: {
            type: responseHeader?.type as PageHeaderType,
            title: responseHeader?.title,
            button: responseHeader?.button,
        },
        sections: buildHomePageSections(
            apiResponse?.body?.sections ?? ([] as any),
            objectGraph,
            sectionInvalidationRules,
        ),
        invalidationRules: {
            eventTriggers: [
                pageSubscriptionStatusChangeEventTrigger(pageIntent),
            ],
        },
        canonicalURL,
        pageMetrics: createPageMetricsForResponse(
            apiResponse,
            PageType.homePage,
        ),
        seoData: getBaseSeoData(canonicalURL, objectGraph, {
            // TODO: rdar://142286614 ([Classical on Web] SEO - Organization Data)
            // showOrgData: true,
            showOrgData: false,
        }),
    };
}
